import { Pipe, PipeTransform } from '@angular/core';

import { userActiveProductIds } from '../constants/constants';
import { ShowAllProductsSelected } from '../models/show-all-products-selected.interface';

@Pipe({ name: 'hasUserEppProduct', standalone: true })
export class HasUserEppProductPipe implements PipeTransform {
  transform(
    section: string,
    areAllProductsSelected: ShowAllProductsSelected,
    userServiceUserData: any,
    productList: any,
    parameterset?: string,
    resolution?
  ): boolean {
    if (areAllProductsSelected[section]) {
      return true;
    }
    const options = parameterset ? { parameterset, resolution } : {};
    const products = userActiveProductIds(
      section,
      userServiceUserData,
      options
    );

    if (!parameterset) {
      if (
        productList.epp &&
        typeof productList.epp === 'object' &&
        Object.keys(productList.epp).length > 0
      ) {
        const pset = Object.keys(productList.epp)[0];
        if (pset && productList.epp.hasOwnProperty(pset)) {
          const res = Object.keys(productList.epp[pset])[0];
          for (const eppProduct of productList.epp[pset][res]) {
            if (products.indexOf(eppProduct.id) >= 0) {
              return true;
            }
          }
        }
      }
    } else {
      const res = resolution.days + '_' + resolution.hourly;
      for (const eppProduct of productList.epp[parameterset][res]) {
        for (const product of products) {
          if (product['id'] === eppProduct.id) {
            if (product['parameterset'] === parameterset) {
              if (product['resolution']['days'] === resolution.days) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }
}
